/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../../../Fixes';
import Builder from '../../../../Builder';
import './phone_number';
import '../../../common/time';
import '../../../connect/v2/resources/address';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "corporate_card": {
        "nested": {
          "resources": {
            "nested": {
              "application_flow": {
                "nested": {
                  "ApplicantIndividual": {
                    "fields": {
                      "phoneNumber": {
                        "type": ".squareup.corporate_card.resources.application_flow.PhoneNumber",
                        "id": 1,
                        "rule": "optional"
                      },
                      "firstName": {
                        "type": "string",
                        "id": 2,
                        "rule": "optional"
                      },
                      "lastName": {
                        "type": "string",
                        "id": 3,
                        "rule": "optional"
                      },
                      "dateOfBirth": {
                        "type": ".squareup.common.time.YearMonthDay",
                        "id": 4,
                        "rule": "optional"
                      },
                      "last4Ssn": {
                        "type": "string",
                        "id": 5,
                        "rule": "optional"
                      },
                      "fullSsn": {
                        "type": "string",
                        "id": 6,
                        "rule": "optional"
                      },
                      "address": {
                        "type": ".squareup.connect.v2.resources.Address",
                        "id": 7,
                        "rule": "optional"
                      },
                      "idvStatus": {
                        "type": ".squareup.corporate_card.resources.application_flow.ApplicantIndividual.IdvStatus",
                        "id": 8,
                        "rule": "optional"
                      },
                      "emailAddress": {
                        "type": "string",
                        "id": 9,
                        "rule": "optional"
                      }
                    },
                    "nested": {
                      "IdvStatus": {
                        "values": {
                          "AI_IS_DO_NOT_USE": 0,
                          "PENDING": 1,
                          "VERIFIED": 2,
                          "FAILED": 3
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicantIndividual && !$root.nested?.squareup?.nested?.corporate_card?.nested?.resources?.nested?.application_flow?.nested?.ApplicantIndividual?.nested?.IdvStatus) {
  $root.addJSON(jsonData);
}

/**
 * --
 * @desc An individual on a credit card application
 * --
 *
 * SOURCE ApplicantIndividual @ squareup/corporate_card/resources/application_flow/applicant_individual.proto at 14:1
 */
export const ApplicantIndividual = $root.lookupType('squareup.corporate_card.resources.application_flow.ApplicantIndividual');
fixType(ApplicantIndividual);
Builder.createAndAttachToType(ApplicantIndividual);
/**
 * SOURCE IdvStatus @ squareup/corporate_card/resources/application_flow/applicant_individual.proto at 15:3
 */
ApplicantIndividual.IdvStatus = $root.lookupEnum('squareup.corporate_card.resources.application_flow.ApplicantIndividual.IdvStatus').values;